/**
 * Часовой пояс портала.
 *
 * Все сроки — заявки, путевые листы, история — портал показывает и собирает в Москве, а не в поясе
 * браузера: у диспетчера из другого региона своя граница суток, и «сегодня» у него разошлось бы с
 * ответом API. Раньше эта константа жила в теме antd — месте для цветов и отступов, куда за
 * часовым поясом никто не полезет.
 */
export const MOSCOW_TZ = 'Europe/Moscow';
